<template>
    <div class="roadTransport">
        <banner :themeColor="'#fff'"></banner>
        <div class="container">
            <div class="midBox">
                <div class="boxTit"> 各国关税担保，无需口岸换装过境手续简化，门到门一车直达</div>
                <div class="columnBox">
                    <div class="tabContent">
                        <div class="tabItem">
                            <div class="imgBgBox imgBgBox1">
                                <div class="titBox">
                                    <!-- <div class="tit">商通中心携手货拉拉，共同为企业客户打造专业的一站式数字化物流解决方案</div> -->
                                    <div class="infoT">
                                        TlR(Transports Internationaux Routiers，国际公路运输公约)是由联合国主导的跨境货运通关系统，覆盖全球80+国家(包括中国、俄罗斯、欧盟、中亚等)
货物在启运国海关验封后，途经各国无需重复开箱查验，直达目的地。
                                    </div>
                                </div>
                                <div class="titImgBox">

                                    <el-image style="width: 100%;height: 100%;"
                                        :src="require('../../assets/images/tir.jpg')" fit="contain" />
                                </div>
                                <!-- <div class="tit">商通中心携手货拉拉，共同为企业客户打造专业的一站式数字化物流解决方案</div>
                                <div class="infoT">                                 
                                        依托货拉拉全国优质运力资源与智能调度系统，致力解决企业在发货流程中面临的环节繁琐、比价困难、货物追踪不便等核心痛点。依托智能报价体系、全程可视化管理和电子化单证服务，为企业提供覆盖全国主要城市的标准化货运服务，有效帮助企业优化物流成本，提升运营效率，实现供应链管理的数字化升级，让物流配送成为企业发展的可靠助力。
                                </div> -->
                            </div>
                            <div class="rowBox rowBox1">
                                <div class="boxItem">
                                    <img src="../../assets/images/gaoxiao.png" alt="">
                                    <div class="tit">高效通关</div>
                                    <div class="infoT">
                                        减少边境滞留时间(平均节省50%以上)，提升运输时效。
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/jdcb.png" alt="">
                                    <div class="tit">降低成本</div>
                                    <div class="infoT">
                                        免除过境国保证金(传统运输需缴纳高额押金)降低企业资金压力。
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/anquan.png" alt="">
                                    <div class="tit">安全可靠</div>
                                    <div class="infoT">
                                        全程电子化追踪+海关铅封，货物安全有保障。
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/fanwei.png" alt="">
                                    <div class="tit">覆盖广泛</div>
                                    <div class="infoT">
                                        连接亚欧大陆核心物流通道，尤其适合中欧班列衔接段的公路运输。
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="btmBox" id="btmBox">
                <div class="boxTit">物流服务产品</div>
                <div class='sjcpBox'>


                    <div class='listBox'>

                        <div class='listItem' v-for='(item, index) in shopList' :key='index'>
                            <div class='zhoubao'>
                                <div class='zbName'>{{ item.cpmc }}</div>
                                <img :src="commenUrl + item.zstp" class='titleImg' alt="" v-if='item.zstp'>
                            </div>
                            <div class='itemBottom'>
                                <div class='nrmk'>
                                    <div class='zbnrbt'>服务内容</div>
                                    <div class='nrWrite'>{{ item.fwnr }}</div>
                                </div>
                                <div class='nrmk'>
                                    <div class='zbnrbt'>应用场景</div>
                                    <div class='nrWrite'>{{ item.yycj }}</div>
                                </div>
                                <div class='nrmk'>
                                    <div class='zbnrbt'>服务对象</div>
                                    <div class='nrWrite'>{{ item.fwdx }}</div>
                                </div>
                                <div class='qwcg' @click=goPage(item.lj)>前往采购</div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </div>
    </div>
</template>
<script>
import { ref, getCurrentInstance, reactive, computed, toRefs, onMounted, nextTick, watch, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
import MapObject from "@/components/map/js/map";
import banner from '@/components/banner.vue'
export default {
    name: "roadTransport",
    props: {
        themeColor: {
            type: String,
            default: 'blue'
        },
    },
    components: {
        banner,
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const route = useRoute();
        const state = reactive({
            tabIndex: 0,
        });

        let falg = ref(false)
        //页面跳转
        const goPage = (url) => {
            if (url) {
                window.open(url);
            }
        };

        //获取数据产品超市列表
        const shopList = ref([])
        const getsjcpShop = () => {
            proxy.$request({
                url: 'QPSTZX_INDEX_WLCPLIST',
                method: "post",
                data: {
                   
                }
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    shopList.value = res.data.result

                }
            }).catch((err) => {
                console.log(err);
            })
        }
        getsjcpShop()





        return {
            goPage,
            ...toRefs(state),
            shopList,
            getsjcpShop



        }
    },
}
</script>
<style lang="less" scoped>
.roadTransport {
    width: 100%;
    height: 100%;
    background: #F7F7F7;
    box-sizing: border-box;
    padding-bottom: 20px;

    div {
        box-sizing: border-box;
        color: #191919;
        font-size: 16px;
        line-height: 22px;
        font-family: PingFangSC, PingFang SC;
    }

    img {
        width: 100%;
        height: 100%;
    }

    .boxTit {
        font-weight: 600;
        font-size: 36px;
        line-height: 50px;
        text-align: center;
    }

    .container {
        width: 1200px;
        margin: 0 auto;

        .midBox {
            .boxTit {
                padding: 50px 0 60px;
            }

            .columnBox {
                .topRow {
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 1px solid #D8D8D8;
                    margin-bottom: 40px;

                    .leftInfo {
                        flex: 1;
                        padding-top: 78px;
                        font-weight: 400;
                        font-size: 18px;
                        color: #595959;
                        line-height: 36px;
                        display: flex;
                        flex-direction: column;

                        .tit {
                            font-weight: 600;
                            font-size: 20px;
                            line-height: 36px;
                            margin-bottom: 28px;
                        }

                        .tabTit {
                            margin-top: auto;
                            display: flex;

                            .titItem {
                                font-weight: 600;
                                margin-right: 40px;
                                padding-bottom: 10px;
                                cursor: pointer;
                            }

                            .active {
                                font-size: 20px;
                                border-bottom: 4px solid #191919;
                                ;
                            }
                        }
                    }

                    .imgBox {
                        width: 47%;
                        height: auto;

                        img {
                            object-fit: contain;
                        }
                    }
                }

                .tabContent {
                    .tabItem {
                        .imgBgBox {
                            min-height: 160px;
                            width: 100%;
                            margin-bottom: 30px;
                            border-radius: 25px;
                            display: flex;
                            align-items: center;

                            .titBox {
                                width: 50%;
                                // flex: 1;
                                padding: 30px 40px 30px 30px;

                                .tit {
                                    font-size: 20px;
                                    line-height: 36px;
                                    // margin-bottom: 16px;
                                    font-weight: bold;
                                }

                                .infoT {
                                    font-weight: 400;
                                    font-size: 16px;
                                    line-height: 32px;
                                    // max-width: 61%;
                                }
                            }

                            .titImgBox {
                                width: 50%;
                                //   flex: 1;
                                padding: 30px 30px 30px 0;

                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }

                        }

                        

                        .imgBox {
                            width: 100%;
                            margin-top: 30px;
                            padding: 32px 170px 39px 69px;
                            background: #FFFFFF;
                            border-radius: 20px;

                            .tit {
                                font-weight: 600;
                                font-size: 20px;
                                line-height: 28px;
                                margin-bottom: 30px;
                            }

                            .img {
                                height: 230px;

                                img {
                                    object-fit: contain;
                                }
                            }
                        }
                    }

                    .boxBtn {
                        width: 156px;
                        height: 46px;
                        border-radius: 23px;
                        border: 1px solid #191919;
                        text-align: center;
                        line-height: 46px;
                        font-weight: 400;
                        font-size: 14px;
                        margin: 0 auto;
                        margin-top: 40px;
                        cursor: pointer;
                    }

                    .rowBox {
                        display: grid;
                        grid-template-columns: repeat(3, 1fr);
                        grid-column-gap: 20px;
                        grid-auto-rows: 230px;

                        .boxItem {
                            padding: 20px;
                            background: #fff;
                            border-radius: 20px;

                            img {
                                width: 50px;
                                height: 50px;
                                margin-bottom: 30px;
                            }

                            .tit {
                                font-weight: 600;
                                font-size: 20px;
                                line-height: 28px;
                                margin-bottom: 8px;
                            }

                            .infoT {
                                font-weight: 400;
                                font-size: 16px;
                                line-height:32px
                            }
                        }
                    }

                    .rowBox1 {
                        grid-template-columns: repeat(4, 1fr);
                        grid-auto-rows: 258px;

                        .boxItem {
                            display: flex;
                            flex-direction: column;

                            .boxBtn {
                                margin-top: auto;
                            }
                        }
                    }

                    .rowBox2 {
                        grid-template-columns: 1fr 3fr;
                        grid-auto-rows: 343px;

                        .boxItem {
                            display: flex;
                            flex-direction: column;

                            .boxBtn {
                                margin-top: auto;
                            }
                        }

                        .innerRowBox {
                            display: flex;
                            justify-content: space-between;
                            column-gap: 50px;
                        }
                    }
                }
            }
        }

        .mapBox {
            width: 100%;

            .boxTit {
                padding: 55px 0 16px;
                font-weight: 600;
                font-size: 36px;
                color: #191919;
            }

            .smallTit {
                font-weight: 400;
                font-size: 18px;
                color: #595959;
                line-height: 36px;
                text-align: center;
            }

            .map_main {
                border-radius: 20px;
                height: 700px;
                width: 100%;
                position: relative;
                margin-top: 32px;
            }
        }


        .btmBox {
            margin: 0 auto 40px;
            width: 1200px;

            .boxTit {
                padding: 60px 0 40px;
            }

            .sjcpBox {
                width: 100%;
                .listBox {
                    display: flex;
                    width: 100%;
                    flex-wrap: wrap;
                    justify-content: left;
                    .listItem {
                        width: 23.7%;
                        background: #fff;
                        border-radius: 20px;
                        margin-right: 20px;
                        margin-bottom: 20px;
                        // float:left;

                        .zhoubao {
                            width: 100%;
                            height: 86px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 0 30px;
                            background: #E8F0FF;

                            .zbName {
                                flex: 1;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 600;
                                font-size: 26px;
                                height: 42px;
                                color: #121C30;
                                text-align: left;
                                line-height: 42px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                padding-right: 30px;
                            }

                            .titleImg {
                                width: 36px;
                                height: 36px;
                            }

                        }

                        .itemBottom {
                            padding: 20px 30px 20px;
                            .nrmk {
                                border-bottom: 1px solid #EBEBEB;
                                margin-bottom: 15px;
                                height: 123px;

                                // background:pink;
                                .zbnrbt {
                                    width: 100%;
                                    height: 40px;
                                    font-family: PingFangSC, PingFang SC;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #747C8D;
                                    line-height: 40px;
                                    text-align: left;
                                    font-style: normal;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }

                                .nrWrite {
                                    height: 80px;
                                    font-family: PingFangSC, PingFang SC;
                                    font-weight: 600;
                                    font-size: 20px;
                                    color: #676D7A;
                                    line-height: 40px;
                                    text-align: left;
                                    font-style: normal;
                                    margin-bottom: 11px;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 2;
                                    /* 限制行数为3 */
                                    overflow: hidden;
                                }
                            }

                            .qwcg {
                                width: 156px;
                                height: 46px;
                                border-radius: 23px;
                                border: 1px solid #191919;
                                margin: 20px auto 0;
                                display: flex;
                                justify-content: space-around;
                                align-items: center;
                                color: #191919;
                                font-size: 14px;
                                cursor: pointer;
                            }

                            .qwcg:hover {
                                width: 156px;
                                height: 46px;
                                border-radius: 23px;
                                border: 1px solid #191919;
                                margin: 20px auto 0;
                                display: flex;
                                justify-content: space-around;
                                align-items: center;
                                color: #fff;
                                font-size: 14px;
                                cursor: pointer;
                                background: #191919;
                            }
                        }

                    }
                }

                .listBox .listItem:nth-child(4n) {
                    margin-right: 0;
                }
            }
        }
    }
}

@media (min-width: 1680px) {
    .roadTransport {
        .container {
            width: 1600px;

            .btmBox {
                width: 1600px;

                .sjcpBox {
                    width: 100%;
                    .listBox {
                        display: flex;
                        width: 100%;
                        // height: 620px;
                        flex-wrap: wrap;
                        justify-content: left;



                        .listItem {
                            width: 24%;
                        }
                    }
                }

            }

            .midBox {
                .columnBox {
                    .topRow {
                        .leftInfo {
                            margin-right: 140px;
                        }

                        .imgBox {
                            width: 48%;
                            height: auto;
                        }
                    }

                    .tabContent {
                        .tabItem {
                            .imgBox {
                                .img {
                                    height: 310px;

                                    img {
                                        object-fit: contain;
                                    }
                                }
                            }
                        }

                        .rowBox {
                            grid-auto-rows: 210px;
                        }

                        .rowBox1 {
                            grid-auto-rows: 241px;
                        }

                        .rowBox2 {
                            grid-auto-rows: 333px;
                        }
                    }
                }

            }
        }
    }
}

#allMap {
    width: 100%;
    height: 100%;
    border-radius: 20px;

}

.allMap_left_box {
    width: 390px;
    height: 640px;
    position: absolute;
    top: 30px;
    left: 30px;
    background: #FFFFFF;
    border-radius: 20px;
    padding: 20px;

    .allMap_box_tit {
        // margin-top: 19px;
        display: flex;
        align-items: center;

        .allMap_box_tit_name {
            font-weight: 600;
            font-size: 18px;
            color: #191919;
            margin-left: 16px;
        }

    }

    .allMap_order_status {
        margin-top: 15px;
        width: 100%;
        height: 445px;
        background: #F5F9FF;
        border-radius: 10px;
        padding: 20px 0 0 17px;
    }

    .allMap_box_info {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;

        .w50 {
            width: 49%;

            .box_cph {
                margin-top: 12px;
                background: #F5F9FF;
                border-radius: 4px;
                border: 1px solid #DDE7F6;
                font-weight: 600;
                font-size: 14px;
                color: #1663FF;
                height: 32px;
                display: flex;
                align-items: center;
                padding-left: 11px;
            }

            .box_gls {
                margin-top: 12px;
                background: #FEF2EA;
                border-radius: 4px;
                border: 1px solid #FCDAC3;
                font-weight: 600;
                font-size: 14px;
                color: #FB9049;
                height: 32px;
                display: flex;
                align-items: center;
                padding-left: 11px;
            }

            .disflex {
                display: flex;
                align-items: center;

                .bgtit {
                    width: 3px;
                    height: 14px;
                    background: #1663FF;
                    margin-right: 8px;

                }

                .bgtit1 {
                    width: 3px;
                    height: 14px;
                    background: #FB9049;
                    margin-right: 8px;
                }

                .w50tit {
                    font-weight: 600;
                    font-size: 14px;
                    color: #595959;
                }
            }

        }
    }
}

:deep(.ol-zoom) {
    display: none;
}

:deep(.el-step__description.is-finish) {
    color: #636D7C;
}

:deep(.el-step__title.is-finish) {
    color: #191919;
}

:deep(.el-step__head.is-finish) {
    color: #CED3DB;
}
</style>